export interface PriceDifferenceResult {
  totalPrice: string;
  increaseOrDecrease: 'increase' | 'decrease' | 'no change';
  increaseDecreaseAmount: string;
}

export function calculatePriceDifference(
  inkTotalPrice: number,
  currentTotalPrice: number
): PriceDifferenceResult {
  const difference = inkTotalPrice - currentTotalPrice;
  let status: 'increase' | 'decrease' | 'no change' = 'no change';

  if (difference > 0) {
    status = 'increase'; // ✅ Check logic here
  } else if (difference < 0) {
    status = 'decrease';
  }

  return {
    totalPrice: formatPrice(Math.abs(difference)),
    increaseOrDecrease: status,
    increaseDecreaseAmount: formatPrice(Math.abs(difference))
  };
}

export function formatPrice(value: number | undefined): string {
  return `$${(value ?? 0).toFixed(2)}`;
}
